import type { GridFilterModel } from "@mui/x-data-grid-premium";
import { arrReplaceMany } from "@exonn/utils";

export const mergeFilterModels = (
  draftModel: GridFilterModel,
  appliedModel: GridFilterModel,
): GridFilterModel => {
  const items = arrReplaceMany(
    appliedModel.items,
    (item, replaceItem) => {
      return item.field === replaceItem.field;
    },
    draftModel.items,
    true,
  );

  const filteredItems = items.filter((item) => {
    if (typeof item.value === "string") {
      return item.value !== "";
    }
    return item.value != null;
  });

  return {
    ...draftModel,
    ...appliedModel,
    items: filteredItems,
  };
};
